<template>
	<div>
		<div style="margin:15px 0">
			<!-- 面包屑 -->
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/couponPackage' }">券包管理</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/couponList' }">优惠券列表</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type === 0 ? '添加' : '编辑' }}优惠券</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<el-form :rules="rules" :model="formList" ref="formList">
			<el-card class="box-card">
				<el-form-item label="券名称：" prop="stock_name" label-width="120px">
					<el-input style="width: 80%" v-model="formList.stock_name" placeholder="例：8月1日活动券"></el-input>
				</el-form-item>
				<el-form-item label="类型" :rules="rules.must" label-width="120px">
					<template>
						<el-select v-model="formList.stock_type" filterable @change="changeType">
							<el-option label="固定面额满减券" value="NORMAL"/>
							<el-option label="折扣券" value="DISCOUNT"/>
							<el-option label="换购券" value="EXCHANGE"/>
						</el-select>
					</template>
				</el-form-item>
				<el-form-item label="备注：" prop="comment" label-width="120px">
					<el-input style="width: 80%" v-model="formList.comment" placeholder="请输入备注"></el-input>
				</el-form-item>
				<el-form-item label="适用商品范围：" prop="goods_name" label-width="120px">
					<el-input style="width: 80%" v-model="formList.goods_name" placeholder="例：指定商品使用"></el-input>
				</el-form-item>
			</el-card>
			<el-card class="box-card" v-if="formList.stock_type==='NORMAL'">
				<h4>固定面额满减券使用规则</h4>
				<el-form-item label="优惠金额（元）" prop="stock_type_money">
					<el-input style="width: 200px" min="1" max="1e7" type="number"
							  v-model.number="formList.stock_type_money"
							  placeholder="请输入优惠金额"></el-input>
				</el-form-item>
				<el-form-item label="消费门槛（元）" prop="transaction_minimum">
					<el-input style="width: 200px" min="1" max="1e7" type="number"
							  v-model.number="formList.transaction_minimum"
							  placeholder="请输入消费门槛"></el-input>
				</el-form-item>
			</el-card>
			<el-card class="box-card" v-else-if="formList.stock_type==='DISCOUNT'">
				<h4>折扣券使用规则</h4>
				<el-form-item label="折扣比例（%）" prop="stock_type_money">
					<el-input style="width: 200px" min="0" max="100" type="number"
							  v-model.number="formList.stock_type_money"
							  placeholder="请输入折扣比例"></el-input>
				</el-form-item>
				<el-form-item label="消费门槛（元）" prop="transaction_minimum">
					<el-input style="width:200px" min="1" max="1e7" type="number"
							  v-model.number="formList.transaction_minimum"
							  placeholder="请输入消费门槛"></el-input>
				</el-form-item>
			</el-card>
			<el-card class="box-card" v-else-if="formList.stock_type==='EXCHANGE'">
				<h4>换购券使用规则</h4>
				<el-form-item label="单品换购价（元）" prop="stock_type_money">
					<el-input style="width: 200px" min="1" max="1e7" type="number"
							  v-model.number="formList.stock_type_money"
							  placeholder="请输入单品换购价"></el-input>
				</el-form-item>
				<el-form-item label="消费门槛（元）" prop="transaction_minimum">
					<el-input style="width:200px" min="1" max="1e7" type="number"
							  v-model.number="formList.transaction_minimum"
							  placeholder="请输入消费门槛"></el-input>
				</el-form-item>
			</el-card>
			<el-card class="box-card">
				<h4>样式信息</h4>
				<el-form-item label="使用须知：">
					<el-input style="width: 80%" type="textarea"
							  :rows="2" v-model="formList.description"
							  placeholder="例：景区门店可用"></el-input>
				</el-form-item>
				<el-form-item label="背景颜色：">
					<template>
						<el-radio-group v-model="formList.background_color">
							<el-radio border v-for="v in wxColors" :label="v.value" style="margin-right: 0">
								<div :style="'width: 30px;height: 20px;display:inline-block;background-color:'+v.color"></div>
							</el-radio>
						</el-radio-group>
					</template>
				</el-form-item>
				<el-form-item label="优惠券图片" prop="coupon_image_url" v-loading="loadImg">
					<el-upload class="avatar-uploader"
							   :action="wxImage"
							   :show-file-list="false"
							   :before-upload="upLoadBefore"
							   :on-error="upLoadError"
							   :on-success="upLoadSuccess">
						<img v-if="formList.coupon_image_url"
							 :src="formList.coupon_image_url" class="avatar" alt="">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<span>券详情图片，850像素*350像素，且图片大小不超过2M</span>
				</el-form-item>
			</el-card>
		</el-form>
		<span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button></span>
	</div>
</template>

<script>
import qs from "qs";
import {wxImage} from "../axios/index";
import coupon from "../api/coupons";

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10,
		}
	},
	data() {
		return {
			wxImage,
			loadImg:false,
			wxColors: [{value: 'Color010', color: '#63B359'},
				{value: 'Color020', color: '#2C9F67'},
				{value: 'Color030', color: '#509FC9'},
				{value: 'Color040', color: '#5885CF'},
				{value: 'Color050', color: '#9062C0'},
				{value: 'Color060', color: '#D09A45'},
				{value: 'Color070', color: '#E48138'},
				{value: 'Color080', color: '#EE903C'},
				{value: 'Color090', color: '#DD6549'},
				{value: 'Color100', color: '#CC463D'},],
			formList: {
				coupon_package_id: undefined,
				stock_name: '',//商家券批次名称
				stock_type: 'NORMAL',//批次类型
				stock_type_money: '',
				transaction_minimum: '',
				comment: undefined,//批次备注
				goods_name: undefined,//商家券批次名称
				description: undefined,
				background_color: undefined,
				coupon_image_url: undefined,//券详情图片
			},
			rules: {
				stock_name: [{required: true, min: 1, max: 21, message: '批次备注1~21字符', trigger: 'blur'}],
				comment: [{required: false, min: 1, max: 20, message: '批次备注1~20字符', trigger: 'blur'}],
				goods_name: [{required: true, min: 1, max: 15, message: '适用商品范围1~15字符', trigger: 'blur'}],
				must: [{required: true, message: '请输入', trigger: 'blur'}],
				coupon_image_url: [{
					required: true,
					min: 1,
					message: '请选择优惠券图片',
					trigger: 'blur'
				}],
				stock_type_money: [{required: true, message: '请输入', trigger: 'blur'}],
				transaction_minimum: [{required: true, message: '请输入', trigger: 'blur'}],
				'coupon_use_rule.discount_coupon.discount_percent': [{
					required: false,
					message: '请输入折扣比例',
					trigger: 'blur'
				}],
				'coupon_use_rule.discount_coupon.transaction_minimum': [{
					required: false,
					message: '请输入消费门槛',
					trigger: 'blur'
				}],
				'coupon_use_rule.exchange_coupon.exchange_price': [{
					required: false,
					message: '请输入单品换购价',
					trigger: 'blur'
				}],
				'coupon_use_rule.exchange_coupon.transaction_minimum': [{
					required: false,
					message: '请输入消费门槛',
					trigger: 'blur'
				}],
			},
			type: 0
		}
	},
	mounted() {
		let query = this.$route.query;
		this.type = query.type;
		this.formList.coupon_package_id = this.$datas.couponPackage.id;
	},
	methods: {
		changeTime(val) {
			if (this.formList.coupon_use_rule.coupon_available_time.available_end_time === '') {
				this.formList.coupon_use_rule.coupon_available_time.available_end_time = this.formList.coupon_use_rule.coupon_available_time.available_begin_time
			}
		},
		changeType() {
			this.formList.stock_type_money = '';
			this.formList.transaction_minimum = '';
			// switch (this.formList.stock_type) {
			// 	case 'NORMAL':
			// 		this.rules['coupon_use_rule.fixed_normal_coupon.discount_amount'][0].required=true;
			// 		this.rules['coupon_use_rule.fixed_normal_coupon.transaction_minimum'][0].required=true;
			// 		this.rules['coupon_use_rule.discount_coupon.discount_percent'][0].required=false;
			// 		this.rules['coupon_use_rule.discount_coupon.transaction_minimum'][0].required=false;
			// 		this.rules['coupon_use_rule.exchange_coupon.exchange_price'][0].required=false;
			// 		this.rules['coupon_use_rule.exchange_coupon.transaction_minimum'][0].required=false;
			// 		break;
			// 	case 'DISCOUNT':
			// 		this.rules['coupon_use_rule.fixed_normal_coupon.discount_amount'][0].required=false;
			// 		this.rules['coupon_use_rule.fixed_normal_coupon.transaction_minimum'][0].required=false;
			// 		this.rules['coupon_use_rule.discount_coupon.discount_percent'][0].required=true;
			// 		this.rules['coupon_use_rule.discount_coupon.transaction_minimum'][0].required=true;
			// 		this.rules['coupon_use_rule.exchange_coupon.exchange_price'][0].required=false;
			// 		this.rules['coupon_use_rule.exchange_coupon.transaction_minimum'][0].required=false;
			// 		break;
			// 	case 'EXCHANGE':
			// 		this.rules['coupon_use_rule.fixed_normal_coupon.discount_amount'][0].required=false;
			// 		this.rules['coupon_use_rule.fixed_normal_coupon.transaction_minimum'][0].required=false;
			// 		this.rules['coupon_use_rule.discount_coupon.discount_percent'][0].required=false;
			// 		this.rules['coupon_use_rule.discount_coupon.transaction_minimum'][0].required=false;
			// 		this.rules['coupon_use_rule.exchange_coupon.exchange_price'][0].required=true;
			// 		this.rules['coupon_use_rule.exchange_coupon.transaction_minimum'][0].required=true;
			// 		break;
			// }
		},
		formatDate(str) {
			if (str === '') {
				this.$message({
					type: 'warning',
					showClose: true,
					message: '请选择日期!'
				});
				return '';
			}
			let arr = str.split(' ').join('T');
			return arr + '+08:00';
		},
		save() {//保存
			let form =Object.assign({},this.formList);
			this.$refs.formList.validate((valid) => {
				if (valid) {
					switch (form.stock_type) {
						case 'NORMAL':
              form.stock_type_money *= 100;
							break;
						case 'DISCOUNT':
							break;
						case 'EXCHANGE':
              form.stock_type_money *= 100;
							break;
					}
          form.transaction_minimum*=100;
					coupon.addCoupon(form).then(res => {
						this.cancel();
					}).catch(err => {
						this.$message({
							type: 'error',
							message: err.msg
						});
					})
				}
			})
		},
		cancel() {
			this.$router.push({
				path: "/couponList",
				query: {}
			});
		},
		upLoadBefore(res){
			this.loadImg=true;
		},
		upLoadError(err){
			this.$message({
				type: 'error',
				message: '上传出错'
			});
			this.loadImg=false;
		},
		upLoadSuccess(res, file) {//上传图片
			if (res.code === 0) {
				this.formList.coupon_image_url = JSON.parse(res.data).media_url;
				this.loadImg=false;
			}
			// console.log(JSON.parse(res.data))
		},
	},
}
</script>

<style>
p span {
	margin: 0 25px;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 178px;
	display: block;
}

.el-radio.is-bordered {
	padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/coupon.vue